import { create } from 'zustand';

// Open/close state for the chapter editor modal. Lives in a store
// (not local state) so the "Chapters" button in the view-tabs row
// can drive the open and read the active style off the same source
// the modal mounts against.
type ChapterEditorState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useChapterEditorStore = create<ChapterEditorState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
